namespace TabAurous.Production {
    export interface TreeMakingBOMForm {
        TransItemId: Serenity.StringEditor;
        TransId: Serenity.StringEditor;
        ProductId: Serenity.StringEditor;
        BomProductId: Serenity.StringEditor;
        AttributeId: Serenity.StringEditor;
        BagNo: Serenity.StringEditor;
        Line_No: Serenity.StringEditor;
        SettingId: Serenity.LookupEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: Serenity.DecimalEditor;
        Purity: Serenity.DecimalEditor;
        PureWeight: Serenity.DecimalEditor;
        CompanyId: Serenity.IntegerEditor;
        FinancialYearId: Serenity.IntegerEditor;
        UserId: Serenity.IntegerEditor;
        RefVoucherId: Serenity.IntegerEditor;
        RefTransId: Serenity.StringEditor;
        RefTransItemId: Serenity.StringEditor;
        RefTransBomId: Serenity.StringEditor;
    }

    export class TreeMakingBOMForm extends Serenity.PrefixedContext {
        static formKey = 'Production.TreeMakingBOM';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!TreeMakingBOMForm.init)  {
                TreeMakingBOMForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.DecimalEditor;

                Q.initFormType(TreeMakingBOMForm, [
                    'TransItemId', w0,
                    'TransId', w0,
                    'ProductId', w0,
                    'BomProductId', w0,
                    'AttributeId', w0,
                    'BagNo', w0,
                    'Line_No', w0,
                    'SettingId', w1,
                    'Pieces', w2,
                    'Weight', w3,
                    'Purity', w3,
                    'PureWeight', w3,
                    'CompanyId', w2,
                    'FinancialYearId', w2,
                    'UserId', w2,
                    'RefVoucherId', w2,
                    'RefTransId', w0,
                    'RefTransItemId', w0,
                    'RefTransBomId', w0
                ]);
            }
        }
    }
}
